import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../../../shared/material/material.module';
import { AccessPlan } from '../../../../core/generated';

export interface PlanDetailsDialogData {
  plan: AccessPlan;
  planTotal: number;
}

@Component({
  selector: 'app-plan-details-dialog',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './plan-details-dialog.component.html',
  styleUrl: './plan-details-dialog.component.scss'
})
export class PlanDetailsDialogComponent {
  private dialogRef = inject(MatDialogRef<PlanDetailsDialogComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: PlanDetailsDialogData) {}

  onClose(): void {
    this.dialogRef.close();
  }

  formatDate(date?: string): string {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('pt-BR');
  }

  formatPrice(price?: number): string {
    if (price === undefined || price === null) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(price);
  }

  formatCpfCnpj(cpfCnpj?: string): string {
    if (!cpfCnpj) return 'N/A';
    const numbers = cpfCnpj.replace(/\D/g, '');
    if (numbers.length === 11) {
      return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    if (numbers.length === 14) {
      return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return cpfCnpj;
  }

  getItemsCount(): number {
    return this.data.plan.items?.length || 0;
  }

  getDiscountsCount(): number {
    return this.data.plan.discounts?.length || 0;
  }

  getDiscountTypeLabel(discount: any): string {
    if ('percentage' in discount && discount.percentage !== undefined) {
      return 'Porcentagem';
    }
    if ('fixedAmount' in discount && discount.fixedAmount !== undefined) {
      return 'Valor Fixo';
    }
    return 'N/A';
  }

  getDiscountValue(discount: any): string {
    if ('percentage' in discount && discount.percentage !== undefined) {
      return discount.percentage + '%';
    }
    if ('fixedAmount' in discount && discount.fixedAmount !== undefined) {
      return this.formatPrice(discount.fixedAmount);
    }
    return 'N/A';
  }

  getDiscountPercentage(discount: any): number | null {
    return discount && discount.percentage !== undefined ? discount.percentage : null;
  }
}
